import React, { useState } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const IsStablingSelect = ({ checkedStablingOption, setCheckedStablingOption, defaultOption = false }) => {

  const [stablingOption, setStablingOption] = useState({
    "1": "Со счета USDT",
    "0": "Со счета выбранной валюты"
  });

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedStablingOption(data);
  };

  return (
    <FormControl>
      <InputLabel id="demo-simple-select-label">Списать с</InputLabel>
      {/* No need to change on Autocomplete component (few options) */}
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={checkedStablingOption ?? null}
        onChange={handleChangeSelect}
      >
        {defaultOption && <MenuItem value={null}>Выбирите вариант</MenuItem>}
        {Object.entries(stablingOption).map(([value, key]) => (
          <MenuItem
            key={key}
            value={value}
          >
            {key}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default IsStablingSelect;